import { buildClassesHook } from '../../../helpers/styles';

export const useClasses = buildClassesHook({
    arrowIcon: {
        fontSize: '1.25rem',
        padding: 0,
    },
});
